import { useEffect } from "react";

import BottonSheet from "src/components/ui/BottonSheet";
import AddProduct from "./AddProduct";
import AddService from "./AddService";
import AddOther from "./AddOther";

import useDeviceSize from "src/hooks/useDeviceSize";

const ProductSheet = ({
  quoList = [],
  dataProductList,
  dataServiceType,
  docType,
  isOpen,
  onClose,
  onAppendData,
  onRemoveElement,
}) => {
  const [deviceWidth] = useDeviceSize();

  useEffect(() => {
    if (deviceWidth > 835) {
      handleClose();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deviceWidth]);

  const getContentComponent = () => {
    switch (docType) {
      case "product":
        return (
          <AddProduct
            quoList={quoList}
            dataProductList={dataProductList}
            onRemoveElement={onRemoveElement}
            onSubmit={onAppendData}
            onClose={handleClose}
          />
        );
      case "service":
        return (
          <AddService
            quoList={quoList}
            dataServiceType={dataServiceType}
            onRemoveElement={onRemoveElement}
            onSubmit={onAppendData}
            onClose={handleClose}
          />
        );
      case "other":
        return (
          <AddOther
            quoList={quoList}
            onRemoveElement={onRemoveElement}
            onSubmit={onAppendData}
            onClose={handleClose}
          />
        );
      default:
        return null;
    }
  };

  const handleClose = () => {
    onClose();
  };

  return (
    <>
      <BottonSheet
        title={
          docType === "product"
            ? `เพิ่มสินค้า`
            : docType === "service"
              ? `เพิ่มรายละเอียดการบริการ`
              : `เพิ่มรายละเอียด`
        }
        onClose={handleClose}
        open={isOpen}
      >
        {getContentComponent()}
      </BottonSheet>
    </>
  );
};

export default ProductSheet;
